import React, { useState, useEffect, useContext, useCallback } from "react";
import { Form, Row, Col, Input, Select, Divider, Spin } from "antd";
import AddPhysicianModalWrapper from "../../../modal/AddPhysicianModalWrapper";
import { CustomButton, CustomSecondaryButton } from "../styled";
import { notify, debounce } from "../../../../utils/helper";
import styled from "styled-components";
import user, { assistantService } from "../../../../services/user";
import { globalRoles } from "../../../../utils/roles";
import { SpecilityContext } from "../../../../context/SpecilityContext";
import { limitedcountry } from "../../../../utils/utils";
import { validateZipCode } from "../../../../utils/utils";
import { LoadingOutlined } from "@ant-design/icons";

const { Option } = Select;

export const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
];

const FormContainer = styled.div`
  max-height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  width: 100%;

  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 8px;
  }

  /* &::-webkit-scrollbar-track {
    background:rgb(138, 136, 136);
    border-radius: 10px;
  } */

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
  // .ant-select-item-option-content {
  //   display: flex;
  //   justify-content: start;
  //   gap: 5px;
  // }

  .customZipSpin {
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 10px
  }
`;

const AddAssistantModal = ({
  isOpen,
  setOpen,
  isEdit,
  setEdit,
  selectedAssistantId,
  fetchAllAssistants,
  physicianList,
  userDetails
}) => {
  const [assistantDataById, setAssistantDataById] = useState([]);
  const [loading, setLoading] = useState(false);
  const { specialtyOptions } = useContext(SpecilityContext);
  const [zip, setZip] = useState('');
  const [countryName, setCountryName] = useState('');
  const [message, setMessage] = useState('');
  const [zipLoading, setZipLoading] = useState(false);
  const [zipData, setZipData] = useState(null);

  const createAssistant = async (assistantData) => {
    try {
      setLoading(true);
      if (isEdit) {
        const payload = {
          ...assistantData,
          zip: zip,
        };
        const response = await assistantService.update(
          selectedAssistantId,
          payload
        );
        notify("success", "Scheduler updated successfully");
      } else {
        const payload = {
          ...assistantData,
          zip: zip,
        };
        const response = await assistantService.create(payload);
        notify("success", "Scheduler added successfully");
      }
      setOpen(false);
      setEdit(false);
      fetchAllAssistants();
      setLoading(false);
    } catch (error) {
      notify("error", error?.data?.message);
      setLoading(false);
    }
  };

  const getAssistantById = async (id) => {
    try {
      const response = await assistantService.getById(selectedAssistantId);
      setAssistantDataById(response?.data);
    } catch (error) {
      notify("error", error?.data);
    }
  };
  useEffect(() => {
    if (selectedAssistantId && isEdit) {
      getAssistantById();
    }
  }, [selectedAssistantId]);

  const [form] = Form.useForm();
  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: assistantDataById?.name || "",
        specialty: assistantDataById?.specialty || "",
        physicianId: assistantDataById?.parent?.id || undefined,
        email: assistantDataById?.email || "",
        zip: assistantDataById?.zip || "",
        country: assistantDataById?.country || "",
      });
    } else {
      form.setFieldsValue({
        name: "",
        physicianId: undefined,
        specialty: undefined,
        email: "",
        zip: "",
        country: undefined,
      });
    }
  }, [assistantDataById, form, isEdit]);

  const onClose = () => {
    setEdit(false);
    setOpen(false);
  };

  const handleZipChange = (e) => {
    const value = e.target.value;
    setZip(value);
    if (value.length >= 3) {
      validateDebounced(value, countryName);
    } else {
      setMessage('');
      setZipData(null);
    }
  };

  const validateDebounced = useCallback(
    debounce(async (zipVal, countryCodeVal) => {
      setZipLoading(true);
      try {
        const msg = await validateZipCode(zipVal, countryCodeVal);
        setMessage(msg.message);
        setZipData(msg.data);
      } catch (err) {
        setMessage('Error validating ZIP');
        setZipLoading(false)
      } finally {
        setZipLoading(false)
      }
    }, 600),
    []
  );

  useEffect(() => {
    if(assistantDataById){
    setCountryName(assistantDataById?.country);
    setZip(assistantDataById?.zip);
    }
  }, [assistantDataById]);
  

  return (
    <AddPhysicianModalWrapper
      show={isOpen}
      setShow={onClose}
      title={
        isEdit ? (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Update Scheduler
            </h3>
            <span className="font-15 text-secondry">
              Edit the Scheduler's information.
            </span>
          </div>
        ) : (
          <div className="row-flex flex-column">
            <h3 className="font-18 font-semibold text-primary mb-5">
              Add New Scheduler
            </h3>
            <span className="font-15 text-secondry">
              Enter the details to add a new scheduler to the platform.
            </span>
          </div>
        )
      }
      footer={null}
      width={570}
      keyClose={false}
      className="custom-detail-modal"
    >
    <Spin spinning={loading}>
      <Form
        form={form}
        layout="vertical"
        onFinish={createAssistant}
      // requiredMark="optional"
      >
        <FormContainer>
          <Row gutter={[24, 8]}>
            <Col span={24}>
              <Form.Item
                name="name"
                label="Full Name"
                rules={[
                  { required: true, message: "Please input the full name!" },
                ]}
              >
                <Input placeholder="Enter Full Name" size="large" />
              </Form.Item>
            </Col>



            <Col span={24}>
              <Form.Item
                name="specialty"
                label="Specialty"
                // placeholder="Select Specialty"
                rules={[
                  { required: true, message: "Please select a specialty!" },
                ]}
              >
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  placeholder="Select Specialty"
                  showSearch
                  style={{ width: '100%' }}
                  dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                  listHeight={userDetails?.role === globalRoles.SUPERADMIN ? 160 : 115}
                  options={specialtyOptions}
                  size="large"
                  loading={loading}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="country"
                label="Country"
                rules={[
                  { required: true, message: "Please select country!" }
                ]}
              >
                <Select
                  getPopupContainer={(triggerNode) => triggerNode.parentNode}
                  style={{ width: '100%' }}
                  placeholder="Select Country"
                  showSearch
                  dropdownStyle={{ maxHeight: 200, overflowY: 'auto', overflowX: 'hidden' }}
                  listHeight={160}
                  value={countryName}
                  onChange={(value)=> setCountryName(value)}
                  optionLabelProp="label"
                  filterOption={(input, option) =>
                    option?.label.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {limitedcountry.map((country) => (
                    <Option
                      value={country.code}
                      label={country.name}
                    >
                      <span>{country.name}</span>
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={16}>
              <Form.Item
                name="zip"
                label="Zip Code"
                rules={[
                  () => ({
                    validator(_, value) {
                      if (!zip) {
                        return Promise.reject(new Error('Please input the zip code!'));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input 
                  type="text"
                  placeholder="Enter Zip Code" 
                  size="large" 
                  value={zip}
                  onChange={handleZipChange}
                  loading={zipLoading}
                />
                {zipLoading ? (
                    <Spin indicator={<LoadingOutlined spin />} className="customZipSpin"/>
                    ):(<span className="customZipSpin font-12 text-primary">{zipData && zipData}</span>)}
                  {message && (
                    <p className="m-0" style={{color: zipData?"green":"red", fontSize: "13px" }}>{message}</p>
                  )}
              </Form.Item>
            </Col>
            {userDetails?.role === globalRoles.SUPERADMIN &&
              <Col span={24}>
                <Form.Item
                  name="physicianId"
                  label="Physician"
                  rules={[
                    { required: true, message: "Please select a physician!" },
                  ]}
                >
                  <Select 
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    showSearch 
                    placeholder="Select Physician" 
                    loading={loading} 
                    filterOption={(input, option) =>
                      option?.label.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {physicianList.map((physician) => (
                      <Option
                        key={physician.id}
                        label={`${physician.name} : ${physician?.specialty} - ${physician?.email}`}
                        value={physician.id}
                        style={{borderBottom: "1px solid var(--border-color)"}}
                      >
                        {physician.name} : {physician?.specialty} - {physician?.email}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>}
            <Col span={24}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: "Please input your email!" },
                  {
                    type: "email",
                    message: "Please enter a valid email address!",
                  },
                ]}
              >
                <Input placeholder="Email address" size="large" />
              </Form.Item>
            </Col>
          </Row>
        </FormContainer>

        <Divider style={{ margin: "20px 0" }} />

        <Row>
          <Col span={24} className="d-flex justify-end gap-12">
            <CustomSecondaryButton
              onClick={() => {
                setEdit(false);
                setOpen(false);
              }}
            >
              Cancel
            </CustomSecondaryButton>
            <CustomButton htmlType="submit" disabled={!isEdit && zipData === null}>
              {loading ? "Processing..." : isEdit ? "Update" : "Add Scheduler"}
            </CustomButton>
          </Col>
        </Row>
      </Form>
    </Spin>
    </AddPhysicianModalWrapper>
  );
};

export default AddAssistantModal;
